module.exports = __webpack_public_path__ + "static/Hotel-07a5edcb13edd82e7ad9de99c13aebf8.jpg";